import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { Dayjs } from "dayjs";

interface DatePickerProps {
  defaultDate: Dayjs | null;
  handleChange: (time: Dayjs | null) => void;
  label: string;
  width?: string;
}

const DatePickerEl = ({
  defaultDate,
  handleChange,
  label,
  width,
}: DatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        format="DD-MM-YYYY"
        sx={{
          width: width || "200px",

          ".MuiInputBase-input": {
            padding: "10px",
            fontSize: "14px",
          },
        }}
        defaultValue={defaultDate}
        label={label}
        onChange={handleChange}
      />
    </LocalizationProvider>
  );
};

export default DatePickerEl;
